import { motion } from 'framer-motion';
import { useGameStore } from '../../store/game.store.js';

interface ClaimBarProps {
  prizes: Record<string, { claimed: boolean; winner: string | null }>;
  onClaim: (prizeType: string) => void;
}

export function ClaimBar({ prizes, onClaim }: ClaimBarProps) {
  const { claimingPrizeType } = useGameStore();

  const claimButtons = [
    { type: 'Early Five', label: 'Early Five', icon: '🖐️' },
    { type: 'Top Line', label: 'Top Line', icon: '⬆️' },
    { type: 'Middle Line', label: 'Middle Line', icon: '↔️' },
    { type: 'Bottom Line', label: 'Bottom Line', icon: '⬇️' },
    { type: 'Four Corners', label: 'Corners', icon: '📐' },
    { type: 'Full House', label: 'Full House', icon: '🏠' },
  ];

  return (
    <div className="w-full flex items-center justify-center p-4 border-t border-white/5 bg-slate-950/20 z-30 select-none">
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 w-full max-w-4xl">
        {claimButtons.map((btn) => {
          const prizeData = prizes[btn.type];
          const isClaimed = prizeData?.claimed;
          const winner = prizeData?.winner;
          const isVerifying = claimingPrizeType === btn.type;

          return (
            <motion.button
              key={btn.type}
              whileHover={isClaimed || isVerifying ? {} : { scale: 1.03 }}
              whileTap={isClaimed || isVerifying ? {} : { scale: 0.97 }}
              onClick={isClaimed || isVerifying ? undefined : () => onClaim(btn.type)}
              disabled={isClaimed || isVerifying}
              style={{
                boxShadow: isClaimed
                  ? 'none'
                  : '0 4px 12px rgba(124, 58, 237, 0.15), inset 0 0 10px rgba(255,255,255,0.02)',
              }}
              className={`flex flex-col items-center justify-center py-2.5 rounded-xl border text-[10px] font-black uppercase tracking-wider transition-all cursor-pointer min-h-[64px] ${
                isClaimed
                  ? 'bg-amber-950/10 border-amber-500/20 text-amber-500/80 cursor-not-allowed shadow-[0_0_10px_rgba(245,158,11,0.05)]'
                  : isVerifying
                    ? 'bg-purple-950/20 border-purple-500/40 text-purple-400 cursor-wait'
                    : 'bg-gradient-to-br from-purple-900/20 via-slate-900/40 to-blue-900/20 border-purple-500/30 hover:border-purple-400 hover:text-white text-surface-200'
              }`}
            >
              {isVerifying ? (
                <div className="w-4 h-4 rounded-full border-2 border-purple-400 border-t-transparent animate-spin mb-1" />
              ) : (
                <span className="text-sm mb-1">{btn.icon}</span>
              )}
              
              <span className="truncate max-w-[85px] font-bold text-[9px]">
                {isVerifying ? 'Checking...' : btn.label}
              </span>
              
              {isClaimed && winner && (
                <span className="text-[7px] text-amber-400 font-black lowercase truncate max-w-[85px] mt-0.5">
                  by {winner}
                </span>
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
export default ClaimBar;
